import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PAGES from "../../../../../constants/pages";
import { BankIdAuthentication } from "../../../authentication";
import {
    PersonalDetails,
    AddMember,
    ErrorPage,
    Receipt,
    Summary as CheckoutSummary,
    B2BPersonalDetails,
    B2BPSummary as B2BCheckoutSummary,
    B2BReceipt,
    B2BOrder,
} from "../../../checkout";
import IncompleteOrder from "../../../checkout/views/IncompleteOrder/IncompleteOrder";
import { InstallEsim } from "../../../esim";
import {
    ChooseSubscription as FWAChooseSubscription,
    Customer as FWACustomer,
    PersonalDetails as FWAPersonalDetails,
    Receipt as FWAReceipt,
    FwaPage,
} from "../../../fwa";

import { Customer as TeliaPlayCustomer, TeliaPlayPage } from "../../../telia-play";
import {
    Summary as OnboardingB2BSummary,
    OnboardingB2BPage,
    PersonalDetails as OnboardingB2BPersonalDetails,
    SubscriptionDetails,
    Receipt as OnboardingB2BReceipt,
} from "../../../onboardingB2B";
import {
    PersonalDetails as PrepaidPersonalDetails,
    PrepaidRegistrationPage,
    Receipt as PrepaidReceipt,
    PrepaidRefillPage,
    PrepaidRefill,
    ChooseRefillPackage,
    PrepaidRefillSummary,
    PaymentProcessing,
    RefillReceipt,
} from "../../../prepaid";
import Queue from "../../../queue/views/Queue";
import {
    AdminLayout,
    LandingPage,
    Orders,
    RetailerPage,
    SalesReportsLayout,
    SalesSupportLayout,
    Shops,
} from "../../../retailer";
import AdditionalServices from "../../../retailer/views/Dashboard/AdditionalServices";
import Customer from "../../../retailer/views/Dashboard/Customer";
import Equipment from "../../../retailer/views/Dashboard/Equipment";
import RetailerReceipt from "../../../retailer/views/Dashboard/Receipt";
import RetailerDashboard from "../../../retailer/views/Dashboard/RetailerDashboard";
import Subscription from "../../../retailer/views/Dashboard/Subscription";
import RetailerSummary from "../../../retailer/views/Dashboard/Summary";
import DraftOrderDetail from "../../../retailer/views/DraftOrders/DraftOrderDetail";
import OrderDetail from "../../../retailer/views/Orders/OrderDetail/OrderDetail";
import RetailerNewOrder from "../../../retailer/views/NewOrder/NewOrder";
import {
    Provisjon,
    SalesReportsHome,
    SalgIdag,
    SalgSisteMaaned,
    SbiRapporter,
} from "../../../retailer/views/SalesReports";
import { Selgere } from "../../../retailer/views/Administration";
import Butikk from "../../../retailer/views/Administration/Butikk";
import {
    BestillSim,
    Dekningskart,
    Eierskifteskjema,
    Nyheter,
    Presentasjoner,
    Provisjonsbulletin,
    Rutiner,
    Skjema,
} from "../../../retailer/views/SalesSupport";
import {
    CommissionAdmin,
    CommissionNumbers,
    DocumentUpload,
    ReviewAdmin,
    NewsAdmin,
    SuperAdminLayout,
    SuperAdminFeedbackList,
} from "../../../retailer/views/SuperAdmin";
import Feedbacks from "../../../retailer/views/Feedbacks/Feedbacks";
import FeedbackDetails from "../../../retailer/views/Feedbacks/FeedbackDetails";
import {
    ConfirmId,
    ConfirmNumber,
    Summary as TransferSummary,
    RequestTransferOfOwnership,
    TransferOwnershipPage,
    LandingPageB2CtoB2C,
    LandingPageB2BtoB2C,
    ConfirmPageToB2B,
    ConsentPageToB2BAndB2C,
    SummaryPageToB2B,
    LandingPagePortInB2C,
    EnterNumberOrEmail,
    LandingPageFromCheckout,
} from "../../../transfer-ownership";
import UpdatePortingDate from "../../../update-porting-date/views/UpdatePortingDate";
import TeliaPlaySummary from "../../../telia-play/views/Summary/Summary";
import TeliaPlayReceipt from "../../../telia-play/views/Receipt/Receipt";

const AppRoutes: React.FC = () => (
    <Routes>
        {/* checkout */}
        <Route path={PAGES.CHECKOUT.QUEUE.URL} element={<Queue />} />
        <Route path={PAGES.CHECKOUT.INCOMPLETE_ORDER_FORM.URL} element={<IncompleteOrder />} />
        {/* /kasse */}
        <Route path={PAGES.CHECKOUT.PERSONAL_DETAILS.URL} element={<PersonalDetails />} />
        <Route path={PAGES.CHECKOUT.ADD_MEMBER.URL} element={<AddMember />} />
        <Route path={`${PAGES.CHECKOUT.ADD_MEMBER.URL}:id`} element={<AddMember />} />
        <Route path={PAGES.CHECKOUT.SUMMARY.URL} element={<CheckoutSummary />} />
        <Route path={`${PAGES.CHECKOUT.RECEIPT.URL}:orderRef/`} element={<Receipt />} />
        <Route path={PAGES.CHECKOUT.ERROR.URL} element={<ErrorPage />} />
        {/* Bedrift */}
        <Route path={PAGES.CHECKOUT_B2B.PERSONAL_DETAILS.URL} element={<B2BPersonalDetails />} />
        <Route path={PAGES.CHECKOUT_B2B.SUMMARY.URL} element={<B2BCheckoutSummary />} />
        <Route path={`${PAGES.CHECKOUT_B2B.RECEIPT.URL}:orderRef/`} element={<B2BReceipt />} />
        <Route path={`${PAGES.CHECKOUT_B2B.ORDER.URL}`} element={<B2BOrder />} />
        {/* Transfer application */}
        <Route
            path={`${PAGES.TRANSFER_OWNERSHIP.LANDING_PAGE_TO_B2B_AND_B2C.URL}:orderItemGuid?/`}
            element={<ConsentPageToB2BAndB2C />}
        />
        <Route path={`${PAGES.TRANSFER_OWNERSHIP.LANDING_PAGE_TO_B2B.URL}:orderGuid/`} element={<ConfirmPageToB2B />} />
        <Route
            path={`${PAGES.TRANSFER_OWNERSHIP.LANDING_PAGE_TO_B2B.SUMMARY}:orderGuid/`}
            element={<SummaryPageToB2B />}
        />
        <Route path={`${PAGES.TRANSFER_OWNERSHIP.LANDING_PAGE_B2C_TO_B2C.URL}`} element={<LandingPageB2CtoB2C />} />
        <Route path={`${PAGES.TRANSFER_OWNERSHIP.LANDING_PAGE_B2B_TO_B2C.URL}`} element={<LandingPageB2BtoB2C />} />
        <Route
            path={`${PAGES.TRANSFER_OWNERSHIP.ENTER_NUMBER_OR_EMAIL.URL}:orderGuid/`}
            element={<EnterNumberOrEmail />}
        />
        <Route
            path={`${PAGES.TRANSFER_OWNERSHIP.LANDING_PAGE_PORTIN_B2C.URL}:orderGuid/`}
            element={<LandingPagePortInB2C />}
        />
        <Route
            path={`${PAGES.TRANSFER_OWNERSHIP.LANDING_PAGE_FROM_CHECKOUT_EXISTING.URL}:orderGuid/`}
            element={<LandingPageFromCheckout />}
        />
        <Route path={PAGES.TRANSFER_OWNERSHIP.URL} element={<TransferOwnershipPage />}>
            <Route path={PAGES.TRANSFER_OWNERSHIP.CONFIRM_ID.SUFFIX} element={<ConfirmId />} />
            <Route path={PAGES.TRANSFER_OWNERSHIP.CONFIRM_NUMBER.SUFFIX} element={<ConfirmNumber />} />
            <Route path={PAGES.TRANSFER_OWNERSHIP.SUMMARY.SUFFIX} element={<TransferSummary />} />
            <Route
                path={PAGES.TRANSFER_OWNERSHIP.REQUEST_TRANSFER_OF_OWNERSHIP.SUFFIX}
                element={<RequestTransferOfOwnership />}
            />
        </Route>
        {/* Update portin date application */}
        <Route path={`${PAGES.UPDATE_PORTING_DATE.URL}:orderItemGuid/`} element={<UpdatePortingDate />} />
        {/* Esim installment application */}
        <Route path={`${PAGES.INSTALL_ESIM.URL}:orderGuid/`} element={<InstallEsim />} />
        {/* FWA checkout */}
        <Route path={PAGES.FWA.URL} element={<FwaPage />}>
            <Route path={`${PAGES.FWA.CHOOSE_SUBSCRIPTION.SUFFIX}`} element={<FWAChooseSubscription />} />
            <Route path={`${PAGES.FWA.CUSTOMER.SUFFIX}`} element={<FWACustomer />} />
            <Route path={`${PAGES.FWA.PERSONAL_DETAILS.SUFFIX}`} element={<FWAPersonalDetails />} />
            <Route path={`${PAGES.FWA.RECEIPT.SUFFIX}:orderRef/`} element={<FWAReceipt />} />
        </Route>
        {/* Authentication via bankid application*/}
        <Route
            path={`${PAGES.AUTHENTICATE_USER_PAGE.BANK_ID.URL}:requestor/:guid?`}
            element={<BankIdAuthentication />}
        />
        {/* Telia Play checkout */}
        <Route path={PAGES.TELIA_PLAY.URL} element={<TeliaPlayPage />}>
            <Route path={`${PAGES.TELIA_PLAY.CUSTOMER.SUFFIX}:packageId/`} element={<TeliaPlayCustomer />} />
            <Route path={`${PAGES.TELIA_PLAY.SUMMARY.SUFFIX}`} element={<TeliaPlaySummary />} />
            <Route path={`${PAGES.TELIA_PLAY.RECEIPT.SUFFIX}:orderRef/`} element={<TeliaPlayReceipt />} />
        </Route>
        {/* prepaid registration */}
        <Route path={PAGES.PREPAID.REGISTRATION.URL} element={<PrepaidRegistrationPage />}>
            <Route index path={`${PAGES.PREPAID.REGISTRATION.URL}`} element={<PrepaidPersonalDetails />} />
            <Route index path={`${PAGES.PREPAID.REGISTRATION.RECEIPT.SUFFIX}`} element={<PrepaidReceipt />} />
        </Route>
        {/* prepaid refill */}
        <Route path={PAGES.PREPAID.REFILL.URL} element={<PrepaidRefillPage />}>
            <Route index path={`${PAGES.PREPAID.REFILL.URL}`} element={<PrepaidRefill />} />
            <Route path={`${PAGES.PREPAID.REFILL.CHOOSE_PACKAGE.URL}`} element={<ChooseRefillPackage />} />
            <Route path={`${PAGES.PREPAID.REFILL.SUMMARY.URL}`} element={<PrepaidRefillSummary />} />
            <Route path={`${PAGES.PREPAID.REFILL.RECEIPT.URL}:orderRef/`} element={<RefillReceipt />} />
            <Route path={`${PAGES.PREPAID.REFILL.PAYMENT_PROCESSING.URL}`} element={<PaymentProcessing />} />
        </Route>
        {/* onboarding b2b */}
        <Route path={PAGES.ONBOARDING_B2B.URL} element={<OnboardingB2BPage />}>
            <Route index path={PAGES.ONBOARDING_B2B.URL} element={<OnboardingB2BPersonalDetails />} />
            <Route path={PAGES.ONBOARDING_B2B.CONTACT_INFORMATION.SUFFIX} element={<OnboardingB2BPersonalDetails />} />
            <Route path={PAGES.ONBOARDING_B2B.SUBSCRIPTION_DETAILS.SUFFIX} element={<SubscriptionDetails />} />
            <Route path={PAGES.ONBOARDING_B2B.SUMMARY.SUFFIX} element={<OnboardingB2BSummary />} />
            <Route path={PAGES.ONBOARDING_B2B.RECEIPT.SUFFIX} element={<OnboardingB2BReceipt />} />
        </Route>
        {/* retailer */}
        <Route path={PAGES.RETAILER.URL} element={<RetailerPage />}>
            <Route index element={<LandingPage />} />
            <Route path={PAGES.RETAILER.SHOPS.SUFFIX} element={<Shops />} />
            <Route path={PAGES.RETAILER.NEWORDER.SUFFIX} element={<RetailerNewOrder />} />
            <Route path={PAGES.RETAILER.ORDERS_OVERVIEW.SUFFIX} element={<Orders />} />
            <Route
                path={`${PAGES.RETAILER.ORDERS_OVERVIEW.SUFFIX}${PAGES.RETAILER.ORDERS_OVERVIEW.DRAFT_DETAIL.SUFFIX}`}
                element={<DraftOrderDetail />}
            />
            <Route
                path={`${PAGES.RETAILER.ORDERS_OVERVIEW.SUFFIX}${PAGES.RETAILER.ORDERS_OVERVIEW.ORDER_DETAIL.SUFFIX}`}
                element={<OrderDetail />}
            />
            <Route path={PAGES.RETAILER.SALES_REPORTS.SUFFIX} element={<SalesReportsLayout />}>
                <Route index element={<SalesReportsHome />} />
                <Route path={PAGES.RETAILER.SALES_REPORTS.SALES_TODAY.SUFFIX} element={<SalgIdag />} />
                <Route path={PAGES.RETAILER.SALES_REPORTS.SALES_LAST_MONTH.SUFFIX} element={<SalgSisteMaaned />} />
                <Route path={PAGES.RETAILER.SALES_REPORTS.COMMISSION.SUFFIX} element={<Provisjon />} />
                <Route path={PAGES.RETAILER.SALES_REPORTS.SBI_REPORTS.SUFFIX} element={<SbiRapporter />} />
            </Route>
            <Route path={PAGES.RETAILER.ADMIN.SUFFIX} element={<AdminLayout />}>
                <Route index element={<Navigate to={PAGES.RETAILER.ADMIN.SHOP.URL} replace />} />
                <Route path={PAGES.RETAILER.ADMIN.SHOP.SUFFIX} element={<Butikk />} />
                <Route path={PAGES.RETAILER.ADMIN.SELLERS.SUFFIX} element={<Selgere />} />
            </Route>
            <Route path={PAGES.RETAILER.SALES_SUPPORT.SUFFIX} element={<SalesSupportLayout />}>
                <Route index element={<Navigate to={PAGES.RETAILER.SALES_SUPPORT.NEWS.URL} replace />} />
                <Route path={PAGES.RETAILER.SALES_SUPPORT.ORDER_SIM.SUFFIX} element={<BestillSim />} />
                <Route path={PAGES.RETAILER.SALES_SUPPORT.OWNERSHIP_TRANSFER.SUFFIX} element={<Eierskifteskjema />} />
                <Route path={PAGES.RETAILER.SALES_SUPPORT.PRESENTATIONS.SUFFIX} element={<Presentasjoner />} />
                <Route path={PAGES.RETAILER.SALES_SUPPORT.FORMS.SUFFIX} element={<Skjema />} />
                <Route
                    path={PAGES.RETAILER.SALES_SUPPORT.COMMISSION_BULLETIN.SUFFIX}
                    element={<Provisjonsbulletin />}
                />
                <Route path={PAGES.RETAILER.SALES_SUPPORT.PROCEDURES.SUFFIX} element={<Rutiner />} />
                <Route path={PAGES.RETAILER.SALES_SUPPORT.NEWS.SUFFIX} element={<Nyheter />} />
                <Route path={PAGES.RETAILER.SALES_SUPPORT.COVERAGE_MAP.SUFFIX} element={<Dekningskart />} />
            </Route>
            <Route path={PAGES.RETAILER.SUPER_ADMIN.COMMISSION_ADMIN.SUFFIX} element={<SuperAdminLayout />}>
                <Route index element={<CommissionAdmin />} />
            </Route>
            <Route path={PAGES.RETAILER.SUPER_ADMIN.COMMISSION_NUMBERS.SUFFIX} element={<SuperAdminLayout />}>
                <Route index element={<CommissionNumbers />} />
            </Route>
            <Route path={PAGES.RETAILER.SUPER_ADMIN.DOCUMENT_UPLOAD.SUFFIX} element={<SuperAdminLayout />}>
                <Route index element={<DocumentUpload />} />
            </Route>
            <Route path={PAGES.RETAILER.SUPER_ADMIN.NEWS_ADMIN.SUFFIX} element={<SuperAdminLayout />}>
                <Route index element={<NewsAdmin />} />
            </Route>
            <Route path={PAGES.RETAILER.SUPER_ADMIN.FEEDBACK_ADMIN.SUFFIX} element={<SuperAdminLayout />}>
                <Route index element={<ReviewAdmin />} />
            </Route>
            <Route path={PAGES.RETAILER.SUPER_ADMIN.FEEDBACK_LIST.SUFFIX} element={<SuperAdminLayout />}>
                <Route index element={<SuperAdminFeedbackList />} />
            </Route>
            <Route path={PAGES.RETAILER.FEEDBACK_DETAILS.SUFFIX} element={<FeedbackDetails />} />
            <Route path={PAGES.RETAILER.FEEDBACKS.SUFFIX} element={<Feedbacks />} />
            <Route path={PAGES.RETAILER.ORDER.SUFFIX} element={<RetailerDashboard />}>
                <Route index path={PAGES.RETAILER.ORDER.CUSTOMER.SUFFIX} element={<Customer />} />
                <Route path={PAGES.RETAILER.ORDER.SUBSCRIPTION.SUFFIX} element={<Subscription />} />
                <Route path={PAGES.RETAILER.ORDER.ADDITIONAL_SERVICES.SUFFIX} element={<AdditionalServices />} />
                <Route path={PAGES.RETAILER.ORDER.EQUIPMENT.SUFFIX} element={<Equipment />} />
                <Route path={PAGES.RETAILER.ORDER.SUMMARY.SUFFIX} element={<RetailerSummary />} />
                <Route path={PAGES.RETAILER.ORDER.RECEIPT.SUFFIX} element={<RetailerReceipt />} />
            </Route>
        </Route>
    </Routes>
);

export default AppRoutes;
